import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, HostBinding, NgModule } from '@angular/core';
import { CoerceBoolean } from '@slidebean/hydra/coercion';

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * Represents an arrow that can be used as part of poppers or dropdowns.
 */
class ArrowComponent {
    constructor() {
        /**
         * Arrow's width in pixels.
         */
        this.width = 10;
        /**
         * Arrow's height in pixels.
         */
        this.height = 5;
        /**
         * Determines whether the arrow is decorative or not for a11y purposes.
         * If it is decorative it will have an `aria-hidden` attribure.
         * @remarks This input will be coerced to a boolean.
         */
        this.decorative = true;
    }
    get display() {
        return 'block';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: ArrowComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.1.4", type: ArrowComponent, selector: "span[hy-arrow], div[hy-arrow], hy-arrow", inputs: { width: "width", height: "height", decorative: "decorative" }, host: { properties: { "style.display": "this.display" } }, ngImport: i0, template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      [attr.aria-hidden]="decorative || null"
      role="img"
      viewBox="0 0 30 10"
      preserveAspectRatio="none"
    >
      <polygon points="0,0 30,0 15,10" fill="currentColor" />
    </svg>
  `, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
__decorate([
    CoerceBoolean()
], ArrowComponent.prototype, "decorative", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: ArrowComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'span[hy-arrow], div[hy-arrow], hy-arrow',
                    template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      [attr.aria-hidden]="decorative || null"
      role="img"
      viewBox="0 0 30 10"
      preserveAspectRatio="none"
    >
      <polygon points="0,0 30,0 15,10" fill="currentColor" />
    </svg>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], propDecorators: { width: [{
                type: Input
            }], height: [{
                type: Input
            }], decorative: [{
                type: Input
            }], display: [{
                type: HostBinding,
                args: ['style.display']
            }] } });
const DIRECTIVES = [ArrowComponent];
class ArrowModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: ArrowModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.1.4", ngImport: i0, type: ArrowModule, declarations: [ArrowComponent], exports: [ArrowComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: ArrowModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: ArrowModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: DIRECTIVES,
                    exports: DIRECTIVES,
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ArrowComponent, ArrowModule };
